module.exports = __webpack_public_path__ + "static/media/home.c1d8b64d.png";